import React from "react";

export default function IconNoData2() {
  return (
    <svg
      width="382"
      height="322"
      viewBox="0 0 382 322"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <line
        opacity="0.6"
        x1="217.557"
        y1="299.184"
        x2="313.15"
        y2="299.184"
        stroke="#696784"
        strokeWidth="4"
        strokeLinecap="round"
      />
      <line
        opacity="0.6"
        x1="2"
        y1="319.718"
        x2="299.507"
        y2="319.718"
        stroke="#120E40"
        strokeWidth="4"
        strokeLinecap="round"
      />
      <line
        opacity="0.6"
        x1="338.979"
        y1="63.7129"
        x2="380"
        y2="63.7129"
        stroke="#120E40"
        strokeWidth="4"
        strokeLinecap="round"
      />
      <ellipse
        opacity="0.6"
        cx="314.468"
        cy="169.074"
        rx="6.13929"
        ry="6.16057"
        fill="#F7871D"
      />
      <ellipse
        opacity="0.6"
        cx="81.175"
        cy="6.16057"
        rx="6.13929"
        ry="6.16057"
        fill="#006000"
      />
      <ellipse
        opacity="0.6"
        cx="269.446"
        cy="6.16057"
        rx="6.13929"
        ry="6.16057"
        fill="#7800B0"
      />
      <ellipse
        opacity="0.6"
        cx="12.9607"
        cy="215.62"
        rx="6.13929"
        ry="6.16057"
        fill="#7800B0"
      />
      <path
        d="M144.501 161.677C94.7764 156.667 26.2057 293.57 31.6878 316.242H196.24C196.24 316.242 204.022 292.003 213.047 268.715C222.905 243.269 233.907 218.08 229.606 205.774C221.376 182.165 205.626 172.043 205.626 172.043L144.501 161.677Z"
        fill="#66BE8F"
      />
      <path
        d="M208.592 242.212C208.592 242.212 216.461 272.851 230.242 289.86C239.321 301.124 247.789 301.049 267.231 301.049C296.626 301.049 226.076 216.505 226.076 216.505L208.592 242.212Z"
        fill="#FFF3E8"
      />
      <path
        d="M217.596 259.071L231.476 226.743L261.569 298.308C256.94 296.774 252.464 294.809 248.2 292.438"
        fill="#797979"
      />
      <path
        d="M163.596 206.993L181.193 205.604L174.246 242.325L163.596 206.993Z"
        fill="#797979"
      />
      <path
        d="M98.2848 188.544C85.452 217.08 109.397 261.662 109.397 261.662L120.072 255.779C120.844 258.442 121.872 261.024 123.14 263.489C120.433 266.142 108.299 271.925 108.299 271.925C103.56 266.005 94.6931 247.293 92.8474 224.703C91.8666 212.391 93.7273 200.018 98.2848 188.544V188.544Z"
        fill="#797979"
      />
      <path
        d="M198.004 175.954C198.004 175.954 210.288 172.713 213.456 174.34C216.623 175.967 238.535 211.311 238.535 211.311L217.596 259.072L212.882 237.194L208.43 244.328L198.004 175.954Z"
        fill="#797979"
      />
      <path
        d="M120.072 255.779L171.952 226.53L188.788 286.193C188.788 286.193 196.345 318.734 171.203 321.762C142.47 325.229 120.072 255.779 120.072 255.779Z"
        fill="#FFF3E8"
      />
      <path
        d="M235.292 134.126C242.626 125.853 242.7 125.365 252.266 129.846C255.321 131.297 255.496 143.788 250.058 152.812C245.918 159.683 233.372 174.677 231.589 175.34C230.616 175.666 233.846 182.6 239.171 193.075C256.294 226.743 283.942 296.093 273.691 299.973C234.719 314.691 213.73 183.901 211.448 178.832C210.3 176.329 216.249 165.165 222.485 154.639C228.72 144.114 235.292 134.126 235.292 134.126Z"
        fill="#FFF3E8"
      />
      <path
        d="M224.355 179.508L239.171 193.012C233.846 182.536 230.616 175.603 231.589 175.277L224.355 179.508Z"
        fill="#797979"
      />
      <path
        d="M211.448 178.77C210.3 176.267 216.249 165.102 222.485 154.577C228.72 144.051 235.292 134.126 235.292 134.126C235.292 134.126 239.159 128.907 241.191 132.311C243.224 135.715 240.855 155.09 236.789 159.846C232.723 164.602 211.448 178.757 211.448 178.757"
        fill="#797979"
      />
      <path
        d="M187.216 194.453L144.49 176.017L181.193 205.604L187.216 194.453Z"
        fill="#797979"
      />
      <path
        d="M211.945 99.3589C224.593 95.9583 231.557 80.888 227.501 65.6984C223.445 50.5089 209.905 40.9519 197.257 44.3525C184.61 47.7531 177.646 62.8234 181.702 78.013C185.758 93.2026 199.298 102.759 211.945 99.3589Z"
        fill="#676681"
      />
      <path
        d="M180.234 74.5466C195.369 70.477 205.26 58.2689 202.325 47.2789C199.391 36.289 184.742 30.679 169.607 34.7486C154.471 38.8181 144.581 51.0263 147.515 62.0162C150.45 73.0061 165.098 78.6162 180.234 74.5466Z"
        fill="#676681"
      />
      <path
        d="M147.078 94.1771C162.213 90.1075 171.922 77.2174 168.763 65.3862C165.604 53.555 150.773 47.263 135.638 51.3325C120.502 55.4021 110.794 68.2922 113.953 80.1234C117.112 91.9546 131.943 98.2467 147.078 94.1771Z"
        fill="#676681"
      />
      <path
        d="M109.841 92.7218C106.367 124.145 115.117 141.202 136.151 148.218L148.136 125.119L126.081 83.2371L109.841 92.7218Z"
        fill="#8F6666"
      />
      <path
        d="M160.256 120.227L152.92 179.208L194.589 219.544L211.811 148.739L160.256 120.227Z"
        fill="#F2D9C3"
      />
      <path
        d="M130.822 134.714L143.443 156.817L151.324 139.97L130.822 134.714Z"
        fill="#676681"
      />
      <path
        d="M199.538 196.817C199.538 196.817 166.714 190.872 165.754 153.688L200.037 164.952L199.538 196.817Z"
        fill="#F2D9C3"
      />
      <path
        d="M195.878 58.2381C216.249 72.9742 224.898 97.2889 224.898 97.2889L208.978 104.394L185.669 67.8246L195.878 58.2381Z"
        fill="#676681"
      />
      <path
        d="M127.692 100.246L137.892 118.572L142.549 126.921L154.992 149.347C158.322 155.287 163.107 160.276 168.894 163.842C174.681 167.408 181.279 169.433 188.064 169.725L209.516 170.669C213.858 170.854 218.187 170.059 222.183 168.343C226.179 166.628 229.741 164.035 232.607 160.756C235.474 157.477 237.571 153.595 238.745 149.395C239.919 145.196 240.141 140.785 239.393 136.488C237.076 122.975 232.966 107.585 223.554 92.5975C218.172 84.1257 210.864 77.0568 202.229 71.972C193.595 66.8872 183.881 63.9317 173.887 63.3485L173.814 63.3679L170.391 63.2647L170.019 63.274C168.331 63.2873 166.615 63.3861 164.926 63.542C160.818 63.9091 156.758 64.6926 152.808 65.8805L140.103 69.6983C137.083 70.6073 134.304 72.1835 131.971 74.311C129.638 76.4386 127.809 79.0636 126.618 81.9933C125.428 84.923 124.907 88.083 125.093 91.2415C125.278 94.3999 126.167 97.4766 127.692 100.246Z"
        fill="#FFF3E8"
      />
      <path
        d="M230.334 123.064C239.542 120.588 244.789 110.278 242.054 100.036C239.319 89.794 229.638 83.4981 220.43 85.9738C211.222 88.4496 205.975 98.7594 208.71 109.002C211.445 119.244 221.126 125.54 230.334 123.064Z"
        stroke="white"
        strokeMiterlimit="10"
      />
      <path
        d="M218.046 101.463C219.291 104.821 218.621 108.163 216.532 108.945C214.443 109.727 211.743 107.641 210.501 104.295C209.259 100.949 209.928 97.6077 212.018 96.8257C214.107 96.0436 216.804 98.1172 218.046 101.463Z"
        fill="#797979"
      />
      <path
        d="M204.724 106.743C211.783 115.962 219.446 116.182 224.392 114.93C225.926 114.539 227.549 114.737 228.944 115.487C230.339 116.237 231.404 117.483 231.929 118.98C232.64 120.978 232.757 123.14 232.268 125.203C231.778 127.267 230.703 129.144 229.172 130.606L218.078 141.182C216.513 142.219 214.75 142.918 212.901 143.232C211.052 143.547 209.158 143.47 207.341 143.007C205.523 142.545 203.821 141.706 202.345 140.546C200.869 139.385 199.65 137.928 198.768 136.267L186.11 112.46L204.724 106.743Z"
        fill="#FFF3E8"
      />
      <path
        d="M222.427 138.224L221.241 136.975L228.569 129.99C229.979 128.642 230.97 126.913 231.422 125.011C231.874 123.11 231.768 121.118 231.117 119.276C230.654 117.996 229.732 116.934 228.531 116.299C227.33 115.664 225.937 115.5 224.622 115.839C219.251 117.193 211.328 116.822 204.06 107.348L205.419 106.296C212.13 115.039 219.342 115.406 224.21 114.201C225.949 113.76 227.79 113.987 229.371 114.837C230.952 115.687 232.16 117.099 232.758 118.796C233.523 120.953 233.647 123.286 233.117 125.513C232.586 127.739 231.423 129.763 229.768 131.339L222.427 138.224Z"
        fill="#F1BCAD"
      />
      <path
        d="M190.563 112.987C191.82 116.341 191.138 119.686 189.049 120.468C186.959 121.251 184.259 119.165 183.017 115.819C181.775 112.473 182.445 109.131 184.531 108.337C186.617 107.543 189.321 109.641 190.563 112.987Z"
        fill="#797979"
      />
      <path
        d="M175.752 106.551C166.274 113.894 161.878 109.18 168.284 102.469C175.175 95.2521 187.534 97.4361 175.752 106.551Z"
        fill="#8F6666"
      />
      <path
        d="M205.146 93.2839C196.46 94.168 197.357 88.2905 204.309 86.3305C211.767 84.2345 215.942 92.182 205.146 93.2839Z"
        fill="#8F6666"
      />
      <path
        d="M215.077 147.305L195.21 145.766C195.21 145.766 197.443 157.28 203.204 158.532C209.477 159.883 215.077 147.305 215.077 147.305Z"
        fill="white"
      />
      <path
        d="M190.439 142.938C199.647 140.463 204.894 130.153 202.159 119.911C199.424 109.669 189.743 103.373 180.535 105.848C171.328 108.324 166.081 118.634 168.815 128.876C171.55 139.118 181.232 145.414 190.439 142.938Z"
        stroke="white"
        strokeMiterlimit="10"
      />
      <path
        d="M167.913 125.4L147.852 125.119"
        stroke="white"
        strokeMiterlimit="10"
      />
      <path
        d="M148.521 67.1358C164.979 88.3012 154.729 126.068 114.34 134.375C88.5316 104.93 81.1124 74.3893 148.521 67.1358Z"
        fill="#676681"
      />
      <path
        d="M152.605 125.512C96.1286 85.7066 95.2041 173.339 157.243 151.877L152.605 125.512Z"
        fill="#FFF3E8"
      />
      <path
        d="M140.195 92.4778L153.289 138.519L150.113 142.145L123.7 101.59L140.195 92.4778Z"
        fill="#676681"
      />
      <path
        d="M137.976 75.3225C173.25 79.288 199.559 61.0965 199.559 61.0965C199.559 61.0965 182.118 38.3296 137.976 75.3225Z"
        fill="#676681"
      />
      <path
        d="M99.0229 91.4196C94.6746 75.1353 78.8505 87.7734 93.9614 94.9962C71.6055 97.8715 95.1098 120.33 102.521 108.243"
        fill="#676681"
      />
      <path
        d="M141.684 168.707C124.948 160.559 106.029 171.323 98.2846 188.544C85.4518 217.08 109.396 261.674 109.396 261.674L120.072 255.779L177.189 229.496C177.189 229.496 167.312 181.21 141.684 168.707Z"
        fill="#66BE8F"
      />
      <path
        d="M174.795 224.027C168.223 252.964 159.032 273.214 162.062 295.605C162.499 298.809 163.509 317.67 156.562 303.44C140.475 270.336 174.795 224.027 174.795 224.027Z"
        fill="#797979"
      />
      <path
        d="M144.49 176.017C138.068 170.21 140.824 153.94 151.836 157.607C162.848 161.274 175.68 161.286 178.424 165.429C181.168 169.572 181.642 177.394 181.642 177.394C181.642 177.394 201.359 182.914 201.359 188.896C201.359 194.879 207.719 260.912 206.596 286.206C205.636 308.059 205.125 321.826 169.42 321.826C148.219 321.826 165.492 265.205 174.832 224.04C178.761 206.744 182.091 194.416 182.091 194.416C182.091 194.416 152.26 183.039 144.49 176.017Z"
        fill="#FFF3E8"
      />
      <path
        d="M181.642 177.393C181.642 177.393 181.18 169.571 178.424 165.428C175.668 161.285 165.379 162.011 154.38 158.332C154.38 158.332 148.219 152.236 143.518 159.909"
        stroke="#797979"
        strokeWidth="1.35"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M251.019 129.258C242.888 128.569 240.892 146.592 240.892 146.592C241.603 153.551 246.043 150.184 247.128 148.369"
        stroke="#797979"
        strokeWidth="1.35"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M231.589 175.277C224.48 182.023 218.544 178.056 218.544 178.056"
        stroke="#797979"
        strokeWidth="1.35"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M154.754 178.895C158.495 180.41 164.282 181.662 166.801 179.897"
        stroke="#797979"
        strokeWidth="1.35"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M163.209 172.887C163.209 172.887 162.623 162.562 167.911 161.623"
        stroke="#797979"
        strokeWidth="1.35"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M179.073 175.215C179.073 175.215 174.246 172.399 178.424 165.402"
        stroke="#797979"
        strokeWidth="1.35"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M149.092 167.28C149.092 167.28 148.182 159.37 154.081 158.519"
        stroke="#797979"
        strokeWidth="1.35"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M122.83 131.937C122.83 131.937 132.586 132.838 137.02 138.177C141.454 143.515 136.188 144.439 136.188 144.439"
        stroke="#797979"
        strokeWidth="1.35"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M128.237 139.035C128.237 139.035 133.587 136.586 137.045 138.17"
        stroke="#797979"
        strokeWidth="1.35"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M109.771 248.796C109.771 248.796 143.904 226.605 172.75 220.322"
        stroke="#797979"
        strokeWidth="1.35"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
